// src/components/Dashboard/Fact.tsx
//
// One labelled value in a detail dialog's facts grid: a caption over the
// value, a third of a row wide. The inquiry dialog had this as a local
// helper; the requisition dialog wrote the same two Typography elements out
// nine times, which is how its labels ended up spaced differently from the
// inquiry's. Both use this now, so the two grids line up.
//
// It is a Grid item, so it belongs inside a <Grid container>.
import { FunctionComponent, ReactNode } from "react";
import { Grid, Typography } from "@mui/material";

type PropsType = {
  label: string;
  /** Spans the full row when the value is prose rather than a field. */
  full?: boolean;
  children: ReactNode;
};

const Fact: FunctionComponent<PropsType> = ({ label, full, children }) => (
  <Grid item xs={full ? 12 : 6} sm={full ? 12 : 4}>
    <Typography variant="caption" color="text.secondary" display="block">
      {label}
    </Typography>
    <Typography variant="body2" component="div">
      {children}
    </Typography>
  </Grid>
);

export default Fact;
